import React from 'react';
import { Grid, makeStyles, Tooltip } from '@material-ui/core';
//import { useHistory } from 'react-router-dom';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import IconButton from '@material-ui/core/IconButton';
import EditSharpIcon from '@material-ui/icons/EditSharp';
import '../listItem.component.scss';
import { globalPageTypeEntity } from '../../../constants/applicationConstants';

const useStyles = makeStyles((theme) => ({
  icon: {
    color: theme.palette.primary.main,
  },
  rounded: {
    backgroundColor: theme.palette.grey[50],
    border: `1px solid #9D9D9D`,
    color: '#9D9D9D',
    width: '30px',
    height: '30px',
    cursor: 'pointer',
  },
  listItem: {
    color: '#434343',
    border: '1px solid #ededed',
    alignItems: 'center',
  },
  recordTypeChip: {
    textTransform: 'capitalize',
    padding: '16px 8px',
    minWidth: '150px',
    borderWidth: '2px',
  },
}));

const DiagnosisCodeListItem = ({
  entityData,
  index,
  listData,
  setListData,
  handleInlineStatusChange,
  addFormPopupHandler,
}) => {
  const classes = useStyles();

  

  function handleStatus(event) {
   
    let item = { ...entityData };
    if (event.target.checked === true) {
      item.current_status = 'ACTIVE';
    } else {
      item.current_status = 'INACTIVE';
    }

    handleInlineStatusChange(item);
  }

  return (
    <Grid container className={classes.listItem}>
      <Grid item xs={12}>
        <Grid container spacing={1} style={{ padding: '20px' }}>
          <Grid
            item
            xs={6}
            className="textItemTitle"
            alignItems="center"
            style={{ display: 'flex' }}
          >
            {entityData.record_number} - {entityData.title}
          </Grid>

          <Grid
            item
            xs={2}
            alignItems="center"
            className="secondaryText"
            style={{ display: 'flex' }}
          >
            Type: {entityData.record_type}
          </Grid>

          <Grid
            item
            xs={2}
            justifyContent="center"
            style={{ display: 'flex' }}
          >
            <FormGroup>
              <FormControlLabel
                control={
                  <Switch
                    color="primary"
                    name="current_status"
                    checked={
                      entityData.current_status == 'ACTIVE' ? true : false
                    }
                    onChange={handleStatus}
                  />
                }
                label={
                  entityData.current_status == 'ACTIVE' ? 'Active' : 'Inactive'
                }
                className="switchLabel"
              />
            </FormGroup>
          </Grid>

          <Grid item xs={2} justifyContent="center" style={{ display: 'flex' }}>
            <Tooltip title="Edit Diagnosis Code" key={index}>
              <IconButton
                color="primary"
                onClick={() => {
                  addFormPopupHandler(globalPageTypeEntity.edit, entityData);
                }}
              >
                <EditSharpIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default DiagnosisCodeListItem;
